import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// GSAP 플러그인 등록 — Aura 공유 setup (Flip/ScrollTrigger/CustomEase/useGSAP)
import '@lashpic/ui/motion/gsap-setup';

import { queryClient } from './lib/query-client';
import { router } from './router';

import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element missing');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
